//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from 'vuex'
import regionSeatLibs from 'utils/regionSeatLibs'
let regionData = JSON.parse(JSON.stringify(regionSeatLibs[0].c))
export default {
  $dictKeyList: [
    {
      key: '2',
      name: '合同状态',
    },
  ],
  data() {
    const that = this
    return {
      filterForm: {
        contractType: 3, //2 托管合同 3流转合同
        contractNum: '',
        trustee: '',
        statusFlag: '',
        trusteeAccountId: '',
      },
      regionProps: {
        value: 'i',
        label: 'n',
        children: 'c',
        lazy: true,
        lazyLoad(node, resolve) {
          const { level, children, label, value, data } = node
          // 直辖市的二级（例：海淀区）flag：true代表直辖市
          if (level == 2 && children.length == 0) {
            that.getChildRegion(value, level >= 3, resolve, true)
          }
          if (level == 3 && children.length == 0 && label != '市辖区') {
            let leaf = false
            if (data.flag) {
              leaf = true
            } else {
              leaf = false
            }
            that.getChildRegion(value, leaf, resolve)
          } else if (level >= 4) {
            that.getChildRegion(value, level >= 4, resolve)
          } else {
            resolve()
          }
        },
      },
      regionData,
      checkedRegionData: [],
      pagination: {
        currentPage: 1,
        pageSize: 10,
        recordTotal: 0,
      },
      allFilters: {},
      contracts: [],
    }
  },
  watch: {
    checkedRegionData(n) {
      this.filterForm.villageId = n[n.length - 1]
    },
  },
  created() {
    this.filterForm.trusteeAccountId = this.$route.query.$businessAccountId
    this.getContractList()
  },
  methods: {
    ...mapActions('addContract', ['setContractInfo']),
    /**
     * @descripttion: 获取地区子级数据
     * @Author: juanjuanhui
     * @Date: 2022-04-02 15:45:04
     * @param {*} value 当前节点的value
     * @param {*} leaf 当前节点的leaf
     * @param {*} resolve
     * @param {*} flag 是否是直辖市的标志 非必传
     */
    getChildRegion(value, leaf, resolve, flag) {
      this.$http.common.getChildRegion({ pid: value }).then((res) => {
        let nodes = res.data
        if (flag) {
          nodes.forEach((item) => {
            item.leaf = leaf
            item.flag = flag
          })
        } else {
          nodes.forEach((item) => {
            item.leaf = leaf
          })
        }
        // 通过调用resolve将子节点数据返回，通知组件数据加载完成
        resolve(nodes)
      })
    },
    /**
     * @descripttion: 获取机手列表
     * @Author: juanjuanhui
     * @Date: 2021-11-23 20:35:33
     * @param {*}
     * @return {*}
     */
    getContractList() {
      this.allFilters = { ...this.filterForm }
      if (this.allFilters.statusFlag == -1) {
        delete this.allFilters.statusFlag
      }
      let { currentPage, pageSize } = this.pagination
      let params = { currentPage, pageSize }
      Object.assign(params, params, this.allFilters)
      this.$http.contract.getContractList(params).then((res) => {
        let { recordTotal, content: contracts } = res.data
        this.pagination.recordTotal = recordTotal
        this.contracts = contracts
      })
    },
    /**
     * @descripttion: 查询数据
     * @Author: juanjuanhui
     * @Date: 2021-06-23 22:07:16
     */
    handleFilterPro() {
      this.pagination.currentPage = 1
      this.getContractList()
    },
    /**
     * @descripttion: 重置筛选条件
     * @Author: juanjuanhui
     * @Date: 2021-06-23 22:08:07
     * @param {String} formName 表单ref名称
     */
    handleResetFilter(formName) {
      this.$refs[formName].resetFields()
      this.checkedRegionData = []
      this.pagination.currentPage = 1
      this.getContractList()
    },
    /**
     * @descripttion: 切换分页
     * @Author: juanjuanhui
     * @Date: 2021-06-23 22:14:09
     * @param {Number} val 当前页码
     */
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.getContractList()
    },
    /**
     * @descripttion: 查看详情
     * @Author: juanjuanhui
     * @Date: 2021-11-24 14:05:16
     * @param {*} params
     */
    handleLookDetail(params) {
      this.$router.push({
        path: '/cooperative/transfer/contract/detail',
        query: { id: params.id },
      })
    },
  },
}
